import { FormDrawer, FormDrawerContent, Id } from "@dgs/core";
import { addMonths, format } from "date-fns";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { BaseApplicationDataFields } from "../../../../applications/BaseApplicationDataFields";
import { useBaseApplicationFormValidate } from "../../../../applications/baseApplicationFormValidate";
import { useCreateApplication } from "../../../../events/eventDetails/applications/create/useCreateApplication";
import { KronosApplicationFormValues } from "../../../../shared/types/application";

interface Props {
	open: boolean;
	onClose: () => void;
	eventId: Id;
}

const formValues: KronosApplicationFormValues = {
	setupDate: format(new Date(), "yyyy-MM-dd"),
	deletionDate: format(addMonths(new Date(), 3), "yyyy-MM-dd"),
	subdomain: "",
	projectNumber: "",
};

export const CreateKronosApplicationDrawer: FC<Props> = ({ eventId, ...props }) => {
	const { t } = useTranslation();
	const { createKronosApplication } = useCreateApplication(eventId);
	const validate = useBaseApplicationFormValidate();

	return (
		<FormDrawer
			{...props}
			title={t("Create KRONOS")}
			validate={validate}
			onSubmit={createKronosApplication}
			initialValues={formValues}
			renderForm={(props) => (
				<FormDrawerContent {...props}>
					<BaseApplicationDataFields />
				</FormDrawerContent>
			)}
		/>
	);
};
